import { affiliateMerchants } from "../../settings/affiliate";
import {
  BrandPowerStations,
  PowerStation,
  PowerStationInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

const combinedTotalMessage = "Jackery two ports combined total.";
const brand = "Jackery";
const rawData: PowerStationInternal[] = [
  // Low DC
  {
    name: "Explorer 2000 Plus",
    link: {
      href: "https://www.jackery.com/products/explorer-2000-plus-portable-power-station?variant=40192995197015",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0C6DHK68Q/",
      affiliate: "https://amzn.to/3O2DTeB",
    },
    img: "/images/products/jackery/explorer-2000-plus/front.webp",

    price: 1099,
    capacity: 2042,
    acOutput: 3000,
    dcOutput: 10,
    solar: 1400,
    expandable: true,

    displayPowerSystemsPage: true,

    captions: {
      solar: combinedTotalMessage,
    },
  },
  {
    name: "Explorer 1000 Plus",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-1000-plus-portable-power-station?variant=40233095135319",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    img: "/images/products/jackery/explorer-1000-plus/front.webp",

    price: 619,
    capacity: 1264,
    acOutput: 2000,
    dcOutput: 10,
    solar: 800,
    expandable: true,

    captions: { solar: combinedTotalMessage },

    displayPowerSystemsPage: true,
  },
  {
    name: "Explorer 1000 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-1000-v2?variant=41738382245975",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0D7PPG25F/",
      affiliate: "https://amzn.to/3QHN5FO",
    },
    img: "/images/products/jackery/explorer-1000-v2/front.webp",

    price: 559,
    capacity: 1070,
    acOutput: 1500,
    dcOutput: 10,
    solar: 400,

    captions: { solar: combinedTotalMessage },

    displayPowerSystemsPage: true,
  },

  {
    name: "Explorer 1500 Ultra",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-1500-ultra-portable-power-station?variant=42447145435223",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GSYKFXF9/",
      affiliate: "https://amzn.to/4tRiowc",
    },
    img: "/images/products/jackery/explorer-1500-ultra/front.webp",

    price: 999,
    capacity: 1536,
    acOutput: 1800,
    dcOutput: 10,
    solar: 800,

    captions: { solar: combinedTotalMessage },
  },
  {
    name: "Explorer 2000 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-2000-v2-portable-power-station?variant=41264600842327",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DFG2WDQH/",
      affiliate: "https://amzn.to/4sMhjoy",
    },
    img: "/images/products/jackery/explorer-2000-v2/front.webp",

    price: 799,
    capacity: 2042,
    acOutput: 2200,
    dcOutput: 10,
    solar: 400,

    captions: { solar: combinedTotalMessage },
  },
  {
    name: "HomePower 3000",
    link: {
      href: "https://www.jackery.com/products/jackery-homepower-3000?variant=41685844983895",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FFSLG3WZ/",
      affiliate: "https://amzn.to/4sKFyU4",
    },
    img: "/images/products/jackery/homepower-3000/front.webp",

    price: 1299,
    capacity: 3072,
    acOutput: 3600,
    dcOutput: 10,
    solar: 1000,

    captions: {
      solar: combinedTotalMessage,
    },
  },

  {
    name: "Explorer 5000 Plus",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-5000-plus?variant=41317177917527",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DWXHJQT5/",
      affiliate: "https://amzn.to/4cmmGGd",
    },
    img: "/images/products/jackery/explorer-5000-plus/front.webp",

    price: 2899,
    capacity: 5040,
    acOutput: 7200,
    dcOutput: 10,
    solar: 4000,
    solar2: 1200,
    expandable: true,

    captions: {
      solar: "Jackery High-PV and Low-PV combined total.",
      solar2: combinedTotalMessage,
    },
  },
  {
    name: "HomePower 3600 Pro Max",
    link: {
      href: "https://www.jackery.com/products/jackery-homepower-3600-pro-max",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0H33PBCHP/",
      affiliate: "https://amzn.to/3SNxLIN",
    },
    img: "/images/products/jackery/homepower-3600-pro-max/front.webp",

    price: null,
    capacity: 3584,
    acOutput: 4000,
    dcOutput: 0,
    solar: 1200,
    expandable: true,

    captions: {
      solar: combinedTotalMessage,
    },
  },
  {
    name: "HomePower 3600 Plus",
    link: {
      href: "https://www.jackery.com/products/jackery-homepower-3600-plus?variant=41939875102807",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FM8653F1/",
      affiliate: "https://amzn.to/48cQeUj",
    },
    img: "/images/products/jackery/homepower-3600-plus/front.webp",

    price: 1599,
    capacity: 3584,
    acOutput: 3600,
    dcOutput: 10,
    solar: 1000,
    expandable: true,

    captions: {
      solar: combinedTotalMessage,
    },
  },
  {
    name: "HomePower 2000 Plus v2",
    link: {
      href: "https://www.jackery.com/products/jackery-homepower-2000-plus-v2",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0H33MZZ95/",
      affiliate: "https://amzn.to/4etghIT",
    },
    img: "/images/products/jackery/homepower-2000-plus-v2/front.webp",

    price: null,
    capacity: 2048,
    acOutput: 2400,
    dcOutput: 10,
    solar: 800,
    expandable: true,

    captions: {
      solar: combinedTotalMessage,
    },
  },
  {
    name: "HomePower 1000 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-homepower-1000-v2",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0CFVBGWBT/",
      affiliate: "https://amzn.to/4oAKomB",
    },
    img: "/images/products/jackery/homepower-1000-v2/front.webp",

    price: null,
    capacity: 1024,
    acOutput: 1500,
    dcOutput: 10,
    solar: 400,
    expandable: false,

    captions: {
      solar: combinedTotalMessage,
    },
  },

  {
    name: "Explorer 1500 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-solar-generator-1500-v2?variant=42138492403799",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0GTLNK14C/",
      affiliate: "https://amzn.to/4tjCXl7",
    },
    img: "/images/products/jackery/explorer-1500-v2/front.webp",

    price: 699,
    capacity: 1536,
    acOutput: 2000,
    dcOutput: 10,
    solar: 400,

    captions: { solar: combinedTotalMessage },
  },
  {
    name: "Explorer 600 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-600-v2-portable-power-station?variant=41993464283223",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/jackery/explorer-600-v2/front.webp",

    price: 499,
    capacity: 640,
    acOutput: 500,
    dcOutput: 10,
    solar: 200,
  },
  {
    name: "Explorer 600 Plus",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-600-plus-portable-power-station?variant=40950098362455",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/jackery/explorer-600-plus/front.webp",

    price: 429,
    capacity: 632,
    acOutput: 800,
    dcOutput: 10,
    solar: 200,
    expandable: false,
  },
  {
    name: "Explorer 300 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-300-v2-portable-power-station?variant=42522801766487",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/jackery/explorer-300-v2/front.webp",

    price: 269,
    capacity: 288,
    acOutput: 300,
    dcOutput: 10,
    solar: 100,
  },
  {
    name: "Explorer 240 v2",
    link: {
      href: "https://www.jackery.com/products/jackery-explorer-240-v2-portable-power-station?variant=41187716890711",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/jackery/explorer-240-v2/front.webp",

    price: 249,
    capacity: 256,
    acOutput: 300,
    dcOutput: 10,
    solar: 100,

    captions: {
      solar:
        "Jackery 8020 to USB-C adapter is required to connect solar panel.",
    },
  },

  {
    name: "FridgeGuard",
    link: {
      href: "https://www.jackery.com/products/jackery-fridge-guard",
      affiliateData: affiliateMerchants.jackery,
      icon: "Jackery",
    },
    // amazon: {
    //   href: null,
    //   affiliate: null,
    // },
    img: "/images/products/jackery/fridgeguard/front.webp?v=2",

    price: null,
    capacity: 1024,
    acOutput: 800,
    dcOutput: null,
    solar: 500,
    expandable: true,

    captions: {
      solar: "Requires Jackery DC Input Module",
    },
  },
];

const powerStations: BrandPowerStations = {
  name: brand,
  powerStations: buildProductRecord<PowerStationInternal, PowerStation>(
    rawData,
    brand
  ),
};

export default powerStations;
